import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import './App.css';
import QRCodeReaction from './containers/QRCodeReaction';
import LeadNote from './containers/LeadNote';
import ByFollowCallStatus from './containers/ByFollowCallStatus';
import AccountSetting from './containers/AccountSetting';
import SendLetter from './containers/SendLetter';
import OrderDashboard from './containers/OrderDashboard';
import LetterAutoGenerate from './containers/LetterAutoGenerate';
import LetterCorrection from './containers/LetterCorrection';
import LetterGenerate from './containers/LetterGenerate';
import CorporateNumberAssign from './containers/CorporateNumberAssign';
import OrderDashboardTimelineStatusType from './containers/OrderDashboardTimelineStatusType';
import OrderList from './containers/OrderList';
import OrderDetail from './containers/OrderDetail';
import DownloadHistory from './containers/DownloadHistory';
import Faq from './containers/Faq';
import FollowCallAppointment from './containers/FollowCallAppointment';
import QuestionnaireThankyou from './components/Questionnaire/pages/Thankyou';
import Signup from './containers/Signup';
import Signin from './containers/Signin';
import Timeline from './containers/Timeline';
import ForgetPassword from './containers/ForgetPassword';
import ProxyLoginUser from './containers/ProxyLoginUser';
import ResetPassword from './containers/ResetPassword';
import ResetPasswordAfterLogin from './containers/ResetPasswordAfterLogin';
import UpdateSecurityQuestion from './containers/UpdateSecurityQuestion';
import Thankyou from './components/Thankyou/Thankyou';
import Loading from './components/Loading/Loading';
import PrivateRoute from './containers/PrivateRoute';
import ErrorBoundary from './components/Error/ErrorBoundary';
import ErrorPage from './components/Error/ErrorPage';
import ExecutiveList from './containers/ExecutiveList'
import NotificationBar from './components/Parts/NotificationBar.jsx'
import PromotePaidPlanDialog from './components/Parts/PromotePaidPlanDialog'
import HouseList from './containers/HouseList';
import SalesforceSetting from './containers/SalesforceSetting';
import SalesforceAddressSetting from './containers/SalesforceAddressSetting'
import SalesforceAddressSetup from './containers/SalesforceAddressSetup'
import SalesforceExeSetting from './containers/SalesforceExeSetting'
import SalesforceExeSetup from './containers/SalesforceExeSetup'
import SalesforceTimelineStatusSetting from './containers/SalesforceTimelineStatusSetting';
import SalesforceTimelineStatusSetup from './containers/SalesforceTimelineStatusSetup';
import SalesforceTimelineStatusSettingEdit from './containers/SalesforceTimelineStatusSettingEdit';
import SalesforceImportHistory from './containers/SalesforceImportHistory'
import SalesforceExportHistory from './containers/SalesforceExportHistory'
import SamlAuthenticated from './containers/SamlAuthenticated'
import Notifications from './containers/Notifications'

import { DashboardTimelineType } from './constants/ComponentTypes';

const NotFound = () => {
  return <ErrorPage code={404} />;
}

class App extends Component {
  state = {
    showNotification: false,
    message: '',
    messageType: 'success',
  };

  componentWillMount() {
    if (!/Chrome/.test(navigator.userAgent)) {
      this.displayNotification(
        (<div>本システムはご利用中のブラウザでの動作を保証しておりません。<a
          style={{
            color: "#71737B",
            textDecoration: "underline",
          }}
          href="https://www.google.com/intl/ja_ALL/chrome/"
          target="_blank" rel="noreferrer noopener">
          Chromeブラウザ
        </a>をダウンロードしてご利用ください。</div>),
        'ghost');
    }
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, width: '98%', left: '1%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false })
          }}
          autoClose={false}
          disableOnclickListener={true}
        >
        </NotificationBar>
      </div>
    );
  };

  renderUserRoutes() {
    return (
      <Switch>
        <PrivateRoute exact path='/house-list/' component={HouseList} />
        <PrivateRoute exact path='/house-list/warning' component={HouseList} />
        <PrivateRoute exact path='/house-list/error' component={HouseList} />
        <PrivateRoute exact path='/house-list/main' component={HouseList} />
        <PrivateRoute exact path='/house-list/ng' component={HouseList} />
        <PrivateRoute exact path='/house-list/:id/timeline' component={Timeline} />
        <PrivateRoute exact path='/executive-list' component={ExecutiveList} />
        <PrivateRoute exact path='/executive-list/:id' component={ExecutiveList} />
        <PrivateRoute exact path='/send-letter' component={SendLetter} />
        <PrivateRoute exact path='/executive-list/:id/timeline' component={Timeline} />
        <PrivateRoute exact path='/letter-generate' component={LetterGenerate} />
        <PrivateRoute exact path='/corporate-number-assign' component={CorporateNumberAssign} />
        <PrivateRoute exact path='/letter-corrections/create' component={LetterCorrection} />
        <PrivateRoute exact path='/letter-auto-generate/create' component={LetterAutoGenerate} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.APPROACH.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.APPOINTMENT.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.CLOSE.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.APPROACH_NG.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.NON_CONNECT.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.DECLINED.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.CONNECT.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={'/order-dashboard' + DashboardTimelineType.SENT_DOCUMENT.path} component={OrderDashboardTimelineStatusType} />
        <PrivateRoute exact path={"/order-dashboard" + DashboardTimelineType.QR_CODE_REACTION.path} component={QRCodeReaction} />
        <PrivateRoute exact path={"/order-dashboard" + DashboardTimelineType.LEAD_NOTE.path} component={LeadNote} />
        <PrivateRoute exact path={"/order-dashboard" + DashboardTimelineType.BY_FOLLOW_CALL_STATUS.path} component={ByFollowCallStatus} />
        <PrivateRoute exact path='/' component={OrderDashboard} />
        <PrivateRoute exec path='/order-dashboard' component={OrderDashboard} />
        <PrivateRoute exact path='/orders' component={OrderList} />
        <PrivateRoute exact path='/orders/:id' component={OrderDetail} />
        <PrivateRoute exact path='/download-history' component={DownloadHistory} />
        <PrivateRoute exact path='/setting' component={AccountSetting} />
        <PrivateRoute exact path='/setting/general' component={AccountSetting} />
        <PrivateRoute exact path='/setting/billing' component={AccountSetting} />
        <PrivateRoute exact path='/setting/plans' component={AccountSetting} />
        <PrivateRoute exact path='/setting/integrations' component={AccountSetting} />
        <PrivateRoute exact path='/setting/integrations/salesforce' component={SalesforceSetting} />
        <PrivateRoute exact path='/setting/integrations/salesforce/address-setting' component={SalesforceAddressSetting} />
        <PrivateRoute exact path='/setting/integrations/salesforce/address-setup' component={SalesforceAddressSetup} />
        <PrivateRoute exact path='/setting/integrations/salesforce/exe-setting' component={SalesforceExeSetting} />
        <PrivateRoute exact path='/setting/integrations/salesforce/exe-setup' component={SalesforceExeSetup} />
        <PrivateRoute exact path='/setting/integrations/salesforce/timeline-status-setup' component={SalesforceTimelineStatusSetup} />
        <PrivateRoute exact path='/setting/integrations/salesforce/timeline-status-setting' component={SalesforceTimelineStatusSetting} />
        <PrivateRoute exact path='/setting/integrations/salesforce/timeline-status-setting-edit' component={SalesforceTimelineStatusSettingEdit} />
        <PrivateRoute exact path='/setting/integrations/salesforce/import-history/:id' component={SalesforceImportHistory} />
        <PrivateRoute exact path='/setting/integrations/salesforce/export-history/:id' component={SalesforceExportHistory} />
        <PrivateRoute exact path='/setting/reset-password' component={ResetPasswordAfterLogin} />
        <PrivateRoute exact path='/setting/update-security-question' component={UpdateSecurityQuestion} />
        <PrivateRoute exact path='/notifications' component={Notifications} />
        <PrivateRoute exact path='/questionnaires/follow-call-appointment/:id/' component={FollowCallAppointment} />
        <PrivateRoute exact path='/questionnaires/follow-call-appointment/:id/thank-you' component={QuestionnaireThankyou} />
        <PrivateRoute exact path='/how-to' component={Faq} />
        <PrivateRoute exact path='/how-to/send-letter' component={Faq} />
        <PrivateRoute exact path='/how-to/send-letter/guide' component={Faq} />
        <PrivateRoute exact path='/how-to/send-letter/tips' component={Faq} />
        <PrivateRoute exact path='/how-to/send-letter/qrcode' component={Faq} />
        <PrivateRoute exact path='/how-to/salesforce' component={Faq} />
        <PrivateRoute exact path='/how-to/salesforce/connect-account' component={Faq} />
        <PrivateRoute exact path='/how-to/salesforce/operation' component={Faq} />
        <PrivateRoute exact path='/how-to/salesforce/duplication' component={Faq} />
        <PrivateRoute exact path='/how-to/faq' component={Faq} />
        <PrivateRoute exact path='/setting/child-accounts' component={AccountSetting} />
        <PrivateRoute exact path='/setting/child-accounts/:id' component={AccountSetting} />
        <PrivateRoute exact path='/setting/child-accounts/authority' component={AccountSetting} />
        <PrivateRoute exact path='/setting/child-accounts/owner' component={AccountSetting} />
        <Route exact path='/thank-you' component={Thankyou} />
        <Route exact path='/loading' component={Loading} />
        <Route exact path='/signup' component={Signup} />
        <Route exact path='/smart-letter-signup' component={Signup} />
        <Route exact path='/keyman-letter-signup' component={Signup} />
        <Route exact path='/posto-signup' component={Signup} />
        <Route exact path='/signin' component={Signin} />
        <Route exact path='/smart-letter-signin' component={Signin} />
        <Route exact path='/keyman-letter-signin' component={Signin} />
        <Route exact path='/posto-signin' component={Signin} />
        <Route exact path='/forget-password' component={ForgetPassword} />
        <Route exact path='/index.html' component={Signin} />
        <Route exact path='/saml-authenticated' component={SamlAuthenticated} />
        <Route path='/reset-password/:token' component={ResetPassword} />
        <Route exact path='/admin/proxy_login/users/:id/:token' component={ProxyLoginUser} />
        <Route component={NotFound} />
      </Switch>
    )
  }

  render() {
    let notification;
    if (this.state.showNotification) { notification = this.renderNotification(); }

    return (
      <div className="App">
        {notification}
        <ErrorBoundary>
          {this.renderUserRoutes()}
          <PromotePaidPlanDialog />
        </ErrorBoundary>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js